String.prototype.replaceAll = function (search, replacement) {
    const target = this;
    return target.split(search).join(replacement);
};

var VM = function () {
    var self = this;
    self.validate = function () {
        document.querySelector('.loading-validator').classList.add('d-block');
        const form = document.querySelector('#validateMe');
        const formData = new FormData(form);
        const serialized = new URLSearchParams(formData).toString();

        fetch("/tools/webconfigvalidatorresult/", {
            method: 'POST',
            headers: {
                '__RequestVerificationToken': document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value'),
            },
            body: formData
        })
        .then(response => response.json())
        .then(response => {
            const content = response.content;
            let annotated = '';

            if (content) {
                const splitted = content.split("\n");
                for (let i = 0; i < response.warnings.length; i++) {
                    const warningMessage = response.warnings[i];
                    if (warningMessage.line) {
                        const warningLine = splitted[warningMessage.line - 1];
                        splitted[warningMessage.line - 1] = '[WARNING]' + warningMessage.text + '[/WARNING]' + warningLine;
                    }
                }
                for (let j = 0; j < response.errors.length; j++) {
                    const errorMessage = response.errors[j];
                    if (errorMessage.line) {
                        const errorLine = splitted[errorMessage.line - 1];
                        splitted[errorMessage.line - 1] = '[ERROR]' + errorMessage.text + '[/ERROR]' + errorLine;
                    }
                }
                const newContent = splitted.join("\n");
                const escaped = escapeHtml(newContent);
                annotated = escaped
                    .replaceAll("[ERROR]", '<span class="fa fa-times-circle me-1" style="color: #e6614f;" title="')
                    .replaceAll("[/ERROR]", '"></span>')
                    .replaceAll("[WARNING]", '<span class="fa fa-exclamation-triangle me-1" style="color: #ffc936;" title="')
                    .replaceAll("[/WARNING]", '"></span>');
            }

            self.content(annotated);
            self.errors(response.errors);
            self.warnings(response.warnings);
            self.apiKey(response.apiKey);
            self.logId(response.logId);
            self.showResult(true);
            // Hljs
            document.querySelectorAll('pre code').forEach(codeElement => {
                hljs.highlightBlock(codeElement);
            });
            document.querySelectorAll('code.hljs.linenumber').forEach(codeElement => {
                hljs.lineNumbersBlock(codeElement);
            });
            // Remove loading animation
            document.querySelector('.loading-validator').classList.remove('d-block');
            // Go to validated result
            const validatorResponsePosition = document.querySelector('#validator-response').getBoundingClientRect().top + window.scrollY - 76;
            window.scroll({ top: validatorResponsePosition, behavior: 'smooth' });
        });
    }

    function escapeHtml(unsafe) {
        return unsafe
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }

    self.input = ko.observable("");
    self.emptyInput = ko.pureComputed(function(){
        return self.input() === "";
    });
    self.showResult = ko.observable(false);
    self.content = ko.observable();
    self.errors = ko.observableArray();
    self.warnings = ko.observableArray();
    self.status = ko.pureComputed(function () {
        if (self.errors() && self.errors().length > 0) return "Invalid";
        if (self.warnings() && self.warnings().length > 0) return "Valid with warnings";
        return "Valid";
    });
    self.icon = ko.pureComputed(function () {
        if (self.errors() && self.errors().length > 0) return "fa-times-circle";
        if (self.warnings() && self.warnings().length > 0) return "fa-exclamation-triangle";
        return "fa-check";
    });
    self.color = ko.pureComputed(function () {
        if (self.errors() && self.errors().length > 0) return "#e6614f";
        if (self.warnings() && self.warnings().length > 0) return "#ffc936";
        return "#0da58e";
    });
    self.apiKey = ko.observable();
    self.logId = ko.observable();
    self.jumpToLine = function (data) {
        // data-line-number
        const elem = document.querySelector("div[data-line-number='" + data.line + "']");
        if (elem) {
            const elemPosition = elem.getBoundingClientRect().top + window.scrollY - 72;
            window.scroll({ top: elemPosition, behavior: 'smooth' });
        }
    };

    self.shareToolbox = ko.pureComputed({
        read: function () {
            var url = encodeURIComponent(window.location.href),
                title = encodeURIComponent(document.title),
                description = encodeURIComponent(document.getElementsByName('description')[0].getAttribute('content'));
            
            return { 
                facebook: 'https://www.facebook.com/sharer.php?u=' + url,
                twitter: 'https://x.com/intent/tweet?url=' + url + '&text=' + title,
                linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + url,
                email: 'mailto:?subject=' + title + '&body=' + description + ' Link: ' + url
            };
        },
        owner: this
    });
};

document.addEventListener("DOMContentLoaded", function () {
    var vm = new VM();
    ko.applyBindings(vm, document.body);
});